import { render, staticRenderFns } from "./addBrandBuild.vue?vue&type=template&id=c7df537e&scoped=true"
import script from "./addBrandBuild.vue?vue&type=script&lang=js"
export * from "./addBrandBuild.vue?vue&type=script&lang=js"
import style0 from "./addBrandBuild.vue?vue&type=style&index=0&id=c7df537e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7df537e",
  null
  
)

export default component.exports